<template lang="pug">
  b-overlay(:show="loading", variant="transparent", spinner-variant="primary")
    b-card
      b-form-group(label-size="sm")
        template(#label)
          .d-flex.justify-content-between
            p.mb-0 Nombre
            b-form-row.mt-2.mt-md-0.justify-content-end.justify-content-md-start
              b-col(cols="auto")
                b-form-checkbox(switch, v-model="rule.enabled", @change="updateRule") {{rule.enabled ? 'Activada' : 'Desactivada'}}
              b-col(cols="auto")
                trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroy")
        b-form-input(placeholder="Nombre de la regla", v-model="rule.name", @input="updateRule")
      b-form-group(label="Descripción", label-size="sm")
        b-form-textarea(placeholder="Descripción", v-model="rule.description", rows="1", max-rows="2", no-resize, @input="updateRule")
      .text-right.mb-3
        b-dropdown(variant="primary", size="sm", right, text="Agregar parámetro")
          b-dropdown-item(v-for="type in param_types", :key="type.value", @click="createParameter(type.value)") {{type.title}}
      empty-message(v-if="!params.length && !loading", message="No hay parámetros creados")
      div(v-for="type in param_types", v-else)
        b-link.text-reset(v-b-toggle="type.value + rule.rule_id")
          h5 {{type.title}}
            chevron-down-icon.ml-1.icon-md
        b-collapse.mb-4(:id="type.value + rule.rule_id", visible)
          b-card.bg-light.py-2.px-3(no-body, v-for="param in params.filter(el => el.type === type.value)", :key="param.rule_param_id")
            .d-flex.justify-content-between.align-items-center
              // DAYS
              b-form-group.mb-0.text-center(v-if="type.value === 'days'")
                b-form-checkbox-group(v-model="param.value", :options="week_days", @change="updateParameter(param)")
              // HOUR RANGE
              b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center(v-if="type.value === 'hour_range'")
                b-col(md="auto")
                  b-form-timepicker(v-model="param.value[0]", hide-header, label-close-button="Seleccionar", close-button-variant="soft-success", locale="es", @hidden="updateParameter(param)")
                b-col.text-center.h5.mb-0(md="auto") a
                b-col(md="auto")
                  b-form-timepicker(v-model="param.value[1]", hide-header, label-close-button="Seleccionar", close-button-variant="soft-success", locale="es", @hidden="updateParameter(param)")
              // DATES
              b-form-row.flex-grow-1(v-if="type.value === 'dates'")
                b-col.mb-2(sm="12", md="5", v-for="(value, index) in param.value", :key="value")
                  date-range-picker.w-100(v-bind="calendar_props", :dateRange="{startDate: $moment(param.value[index], 'DD/MM/YYYY').format()}", @update="updateDate(index, param, 'DD/MM/YYYY', $event)")
                    template.w-100(v-slot:input="picker")
                      b-input-group
                        b-form-input.readonly-white(placeholder="Seleccionar fecha...", size="sm", :value="$moment(param.value[index], 'DD/MM/YYYY').format('LL')", readonly)
                        b-input-group-append
                          b-button(variant="soft-danger", size="sm", @click.stop="removeDate(index, param)")
                            trash-2-icon.icon-md
              // RECURRENT DATES
              b-form-row.flex-grow-1(v-if="type.value === 'recurrent_dates'")
                b-col.mb-2(sm="12", md="5", v-for="(value, index) in param.value", :key="value")
                  date-range-picker.w-100(v-bind="calendar_props", :dateRange="{startDate: $moment(param.value[index], 'DD/MM').format()}", @update="updateDate(index, param, 'DD/MM', $event)")
                    template.w-100(v-slot:input="picker")
                      b-input-group
                        b-form-input.readonly-white(placeholder="Seleccionar fecha...", size="sm", :value="$moment(param.value[index], 'DD/MM').format('D [de] MMMM')", readonly)
                        b-input-group-append
                          b-button(variant="soft-danger", size="sm", @click.stop="removeDate(index, param)")
                            trash-2-icon.icon-md
              // CONFIG
              b-form-row.ml-2.justify-content-center
                b-col(cols="auto")
                  b-form-checkbox(switch, v-model="param.enabled", size="sm", @change="updateParameter(param)") {{param.enabled ? 'On' : 'Off'}}
                b-col(cols="auto")
                  trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroyParameter(param)")
            .text-right(v-if="type.value === 'dates' || type.value === 'recurrent_dates'")
              b-button(variant="link", size="sm", @click="addDate(param, type.value)")  + Agregar {{type.title}}
</template>

<script>
import {mapActions} from "vuex";
import threeSelectOptions from '../data/treeselect-options'
import _debounce from "lodash.debounce";
import Days from '../data/days'
import Months from '../data/months'
import Chart from 'chart.js';

export default {
  data () {
    return {
      threeSelectOptions:threeSelectOptions,
      loading: false,
      calendar_props: {
        singleDatePicker: true,
        ranges: false,
        showDropdowns: true,
        opens: 'right',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        },
        parentEl: '#router-container'
      },
      params: [],
      param_types: [
        {title: 'Días de la semana', value: 'days'},
        {title: 'Rango de horas', value: 'hour_range'},
        {title: 'Fechas específicas', value: 'dates'},
        {title: 'Fechas recurrentes', value: 'recurrent_dates'}
      ],
      week_days: [
        {text: 'LUN', value: 'Monday'},
        {text: 'MAR', value: 'Tuesday'},
        {text: 'MIÉ', value: 'Wednesday'},
        {text: 'JUE', value: 'Thursday'},
        {text: 'VIE', value: 'Friday'},
        {text: 'SÁB', value: 'Saturday'},
        {text: 'DOM', value: 'Sunday'}
      ],
    }
  },
  props: {
    rule: {
      type: Object,
      default: () => {
        return {
          name: "",
          description: "",
          enabled: true,
        }
      }
    }
  },
  computed: {
    parse_dates () {
      return this.$moment(this.dates.startDate).format('DD MMM YYYY') + ' - ' + this.$moment(this.dates.endDate).format('DD MMM YYYY')
    },
  },
  methods: {
    ...mapActions(['rule/params', 'rule/update', 'rule/destroy', 'rule/create_parameter', 'rule/update_parameter', 'rule/destroy_parameter']),
    getParams () {
      let self = this
      this.loading = true

      this['rule/params']({
        ...self.rule,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.params = res.resource.map(el => {
              el.value = JSON.parse(el.value)
              return el
            })
          }
        }
      })
    },
    updateRule: _debounce(function () {
      let self = this
      this.loading = true

      this['rule/update']({
        ...this.rule,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Regla actualizada')
          }
        }
      })
    }, 1000, {leading: false, trailing: true}),
    confirmDestroy () {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la regla ${this.rule.name || ''}? No se puede deshacer.`, {
        title: 'Eliminar regla',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
          this.destroyRule()
        }
      })
    },
    destroyRule () {
      let self = this
      this.loading = true

      this['rule/destroy']({
        ...this.rule,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Regla eliminada')
          }
        }
      })
    },
    createParameter (type) {
      let self = this

      this['rule/create_parameter']({
        rule_id: self.rule.rule_id,
        type: type,
        value: type === 'hour_range' ? ['05:00', '17:00'] : [],
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            res.resource.value = JSON.parse(res.resource.value)
            self.params.push(res.resource)
            self.$message.success('Parámetro creado')
          }
        }
      })
    },
    _updateParameter: _debounce(function (param) {
      this.updateParameter(param)
    }, 1000, {leading: false, trailing: true}),
    updateParameter (param) {
      let self = this
      this['rule/update_parameter']({
        ...param,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Parámetro actualizado')
          }
        }
      })
    },
    confirmDestroyParameter (param) {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar parámetro? No se puede deshacer.`, {
        title: 'Eliminar parámetro',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
          this.destroyParameter(param)
        }
      })
    },
    destroyParameter (param) {
      let self = this
      this.loading = true

      this['rule/destroy_parameter']({
        ...param,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Parámetro eliminado')
            let index = this.params.findIndex(el => el.rule_param_id === param.rule_param_id)
            if(index >= 0) {
              this.params.splice(index, 1)
            }
          }
        }
      })
    },
    setDateRange (value, format) {
      let date = this.$moment(value, format).format()
      return {
        startDate: date,
      }
    },
    addDate (param, value) {
      param.value.push(this.$moment().format(value === 'dates' ? 'DD/MM/YYYY' : 'DD/MM'));
      this.updateParameter(param)
    },
    updateDate (index, param, format, {startDate}) {
      param.value[index] = this.$moment(startDate).format(format)
      this.updateParameter(param)
    },
    removeDate (index, param) {
      param.value.splice(index, 1)
      this.updateParameter(param)
    }
  },
  mounted() {
    this.getParams()
  }
}
</script>

<style lang="scss" scoped>

  @keyframes grow {
    from {
      transform: scaleX(0);
    }
    to {
      transform: scaleX(1);
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>
